import { Link } from 'react-router-dom'
import type { WatchPart } from '../api/client'
import { compatibilityChips, formatLabel } from '../lib/partDisplay'
import { providerDisplayName } from '../outbound/links'

type CatalogPartGridCardProps = {
  part: WatchPart
  hasOverride: boolean
}

export function CatalogPartGridCard({ part, hasOverride }: CatalogPartGridCardProps) {
  const chips = compatibilityChips(part, 3)
  const providerLabel = providerDisplayName(part.provider_id)

  return (
    <Link
      to={`/admin/catalog/${encodeURIComponent(part.id)}`}
      className="catalog-grid-card"
    >
      <div className="catalog-grid-card-image">
        {part.image_url ? (
          <img src={part.image_url} alt={part.name} loading="lazy" />
        ) : (
          <div className="catalog-grid-card-placeholder">
            <span>{part.type.slice(0, 2).toUpperCase()}</span>
          </div>
        )}
        {hasOverride ? <span className="catalog-grid-card-badge">Overridden</span> : null}
      </div>
      <div className="catalog-grid-card-body">
        <span className="catalog-grid-card-type">{formatLabel(part.type)}</span>
        <h3 className="catalog-grid-card-name">{part.name}</h3>
        <span className="catalog-grid-card-provider">{providerLabel}</span>
        {chips.length > 0 ? (
          <div className="catalog-grid-card-chips">
            {chips.map((chip) => (
              <span key={chip} className="catalog-chip">{chip}</span>
            ))}
          </div>
        ) : null}
      </div>
    </Link>
  )
}
